import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { BaseUiModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-news-unread-counter',
  imports: [CommonModule, BaseUiModule],
  templateUrl: './news-unread-counter.component.html',
  styleUrls: ['./news-unread-counter.component.scss'],
})
export class NewsUnreadCounterComponent {
  readonly unreadNews = input<number>();

  badgeClick = output<void>();

  onBadgeClickHandler(): void {
    this.badgeClick.emit();
  }
}
